<template>
  <div
    class="aletta-j"
    :class="fadeClasses"
  >
    <img
      alt=""
      class="aletta-left"
      :src="require('@/assets/images/aletta-left.gif')"
      draggable="false"
    />
    <img
      alt=""
      class="aletta-right"
      :src="require('@/assets/images/aletta-right.gif')"
      draggable="false"
    />
  </div>
</template>

<script>
import { fadeMixin } from '@/mixins'
import { TweenMax } from 'gsap'

export default {
  name: 'Aletta',
  mixins: [fadeMixin],
  watch: {
    done () {
      TweenMax.to('.aletta-right', 1, {
        x: 50,
        delay: 3.5
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.aletta-j {
  position: relative;
  z-index: 2;
  text-align: center;
  padding-bottom: 60px;
}

.aletta-left {
  width: 180px;
  height: 254px;
  display: inline-block;
  vertical-align: bottom;

  @media (min-width: 768px) {
    width: 234px;
    height: 330px;
  }

  @media (max-width: 349px) {
    width: 144px;
    height: 203.2px;
  }
}

.aletta-right {
  width: 130px;
  height: 236px;
  display: inline-block;
  vertical-align: bottom;

  @media (min-width: 768px) {
    width: 169px;
    height: 306px;
  }

  @media (max-width: 349px) {
    width: 104px;
    height: 188.8px;
  }
}
</style>
